import cn from 'classnames'
import React from 'react'
import { NavLink, useHistory, useLocation, useParams } from 'react-router-dom'

export default function EmployeeTabs() {
    const { buildId } = useParams()
    const history = useHistory()

    const location = useLocation()
    const handleBack = () => {
        history.push(`/building/${buildId}`)
    }

    return (
        <div className="tabs">
            <ul>
                <li style={{ cursor: 'pointer' }} onClick={handleBack}>
                    <span className="icon-text">
                        <span className="icon">
                            <ion-icon name="arrow-back-outline" />
                        </span>
                    </span>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': location.pathname.startsWith(`/building/${buildId}/employee`) })}>
                    <NavLink to={`/building/${buildId}/employee`}>Ходимлар</NavLink>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': location.pathname.startsWith(`/building/${buildId}/salary`) })}>
                    <NavLink to={`/building/${buildId}/salary`}>Ходимнинг иш ҳақи</NavLink>
                </li>
            </ul>
        </div>
    )
}
